<template>
  <div>
    
  </div>
</template>

<script>
export default {
    props: {
        availablePages: {
            type: Array,
            required: true
        }
    }
}
</script>

<style>

</style>